import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { DocMetaResponse } from '@qtek/shared/models';
import { TermSheetActions } from './term-sheet.actions';

export interface TermSheetState {
  docMeta: Record<string, DocMetaResponse> | null;
  error: Error | null;
}

const initialState: TermSheetState = {
  docMeta: null,
  error: null,
};

export const termSheetReducer = createReducer(
  initialState,
  on(TermSheetActions.getDocMetaSuccess, (state, { mysid, res }) => ({
    ...state,
    docMeta: {
      ...state.docMeta,
      [mysid]: res,
    },
    error: null as Error | null,
  })),
  on(TermSheetActions.getDocMetaFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(TermSheetActions.unsubscribeDocMeta, (state, { mysid }) => {
    const newDocMeta = { ...state.docMeta };
    if (newDocMeta && mysid in newDocMeta) {
      delete newDocMeta[mysid];
    }
    return {
      ...state,
      docMeta: Object.keys(newDocMeta).length > 0 ? newDocMeta : null,
    };
  })
);

export const TermSheetFeature = createFeature({
  name: 'termSheet',
  reducer: termSheetReducer,
});

export const {
  selectDocMeta: selectTermSheetDocMeta,
  selectError: selectTermSheetError,
} = TermSheetFeature;

export const selectTermSheetDocMetaByMysid = (mysid: string) =>
  createSelector(selectTermSheetDocMeta, docMeta =>
    docMeta ? docMeta[mysid] : null
  );
